import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { createSelector } from 'reselect'
import { RootState } from 'stores'
import { Age } from 'types/age'
import { Education } from 'types/education'
import { Gender } from 'types/gender'
import { updateAge, updateEducation, updateGender } from './actions'
import { Demographics } from './component'
import { DemographicsActions } from './index'

/** Get sub tree for demographics */
const getDemographics = (state: RootState) => state.demographics

const getAge = createSelector(
  getDemographics,
  demographics => demographics.age
)

const getGender = createSelector(
  getDemographics,
  demographics => demographics.gender
)

const getEducation = createSelector(
  getDemographics,
  demographics => demographics.education
)

const mapStateToProps = (state: RootState) => ({
  age: getAge(state),
  education: getEducation(state),
  gender: getGender(state)
})

const mapDispatchToProps = (dispatch: Dispatch<DemographicsActions>) => ({
  handleAgeUpdate: (age: Age) => dispatch(updateAge(age)),
  handleEducationUpdate: (education: Education) =>
    dispatch(updateEducation(education)),
  handleGenderUpdate: (gender: Gender) => dispatch(updateGender(gender))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Demographics)
